export default __webpack_public_path__ + "media/images/services-11-370x250-d2b66687b31c6fb54628a05261accbfa.jpg";